import {Injectable} from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';
import {IMetaTags} from '../models/metatags.model';
import {HOME_META_TAGS} from '../components/home/const';
import {SistemaService} from './sistema/sistema.service';

@Injectable({providedIn: 'root'})
export class SeoService {
  constructor(private meta: Meta, private title: Title, private sistemaService: SistemaService) {
    this.defaultMetaTags();
  }

  defaultMetaTags(): void {
    const now = new Date();
    this.addMetaTags({
      title: HOME_META_TAGS.title,
      description: HOME_META_TAGS.description,
      image: this.sistemaService.baseUrl + HOME_META_TAGS.image,
      published_time: now.toString(),
      modified_time: '',
      fbAppID: 523478911392476,
      url: window.location.href,
      keywords: '',
      date: now.toString(),
      author: 'Bamba',
      type: 'website',
    });
  }

  addMetaTags(metaTags: IMetaTags): void {
    this.meta.addTag({name: 'description', content: metaTags.description});
    this.meta.addTag({name: 'keywords', content: metaTags.keywords});
    this.meta.addTag({name: 'date', content: metaTags.date, scheme: 'YYYY-MM-DD'});
    this.meta.addTag({name: 'author', content: metaTags.author});
    this.meta.addTag({name: 'image', content: metaTags.image});
    // fb meta tags
    this.meta.addTag({property: 'og:title', content: metaTags.title});
    this.meta.addTag({property: 'og:type', content: 'website'});
    this.meta.addTag({property: 'og:description', content: metaTags.description});
    this.meta.addTag({property: 'og:image', content: metaTags.image});
    this.meta.addTag({property: 'og:url', content: metaTags.url});
    // twitter meta tags
    this.meta.addTag({property: 'twitter:card', content: metaTags.description});
    this.meta.addTag({property: 'twitter:title', content: metaTags.title});
    this.meta.addTag({property: 'twitter:description', content: metaTags.description});
    this.meta.addTag({property: 'twitter:image:src', content: metaTags.image});
  }

  updateMetaTags(metaTags: Partial<IMetaTags>): void {
    const metaMap = new Map(Object.entries(metaTags));
    if (metaMap.get('description')) {
      this.meta.updateTag({name: 'description', content: metaTags.description});
      this.meta.updateTag({property: 'og:description', content: metaTags.description});
      this.meta.updateTag({property: 'twitter:card', content: metaTags.description});
      this.meta.updateTag({property: 'twitter:description', content: metaTags.description});
    }

    if (metaMap.get('title')) {
      this.title.setTitle(metaTags.title);
      this.meta.updateTag({property: 'og:title', content: metaTags.title});
      this.meta.updateTag({property: 'twitter:title', content: metaTags.title});
    }

    if (metaMap.get('keywords')) {
      this.meta.updateTag({name: 'keywords', content: metaTags.keywords});
    }

    if (metaMap.get('date')) {
      this.meta.updateTag({name: 'date', content: metaTags.date});
    }

    if (metaMap.get('author')) {
      this.meta.updateTag({name: 'author', content: metaTags.author});
    }

    if (metaMap.get('image')) {
      this.meta.updateTag({name: 'image', content: metaTags.image});
      this.meta.updateTag({property: 'og:image', content: metaTags.image});
      this.meta.updateTag({property: 'twitter:image:src', content: metaTags.image});
    }

    if (metaMap.get('type')) {
      this.meta.updateTag({property: 'og:type', content: metaTags.type});
    }

    if (metaMap.get('url')) {
      this.meta.updateTag({property: 'og:url', content: metaTags.url});
    }
  }
}
